import { IAllUsersDataEnt } from 'src/redux/features/users/allUsers/types';
import { ApiUrlEnum } from '../enum';
import {
  IAllModels,
  IEditModelList,
  IEditUsers,
  ILoadEditUsers,
} from '../type';
import { get, putData } from './api';

export default {
  loadUserInit: () => get(ApiUrlEnum.USER_INIT),
  loadAllUsers: () => get(ApiUrlEnum.USERS),
  loadCurrentUsers: () => get(ApiUrlEnum.USERS_CURRENT),
  loadAllUsersAdministration: (params: string) =>
    get(`${ApiUrlEnum.USERS}${params}`),
  loadEditUsers: (id: string, data: ILoadEditUsers): Promise<IEditUsers> =>
    putData(`${ApiUrlEnum.USERS}/${id}`, data),
  loadModelList: (id: string): Promise<IAllModels> =>
    get(`${ApiUrlEnum.USERS}/${id}/models`),
  loadEditModelList: (
    id: string,
    data: IEditModelList,
  ): Promise<IAllUsersDataEnt> =>
    putData(`${ApiUrlEnum.USERS}/${id}/models`, data),
};
